import cx from 'classnames';
import { useTranslation } from 'react-i18next';

export const EventDetailsTabs = ({
    responsesSelected,
    preview,
    onSelect,
}: {
    responsesSelected: boolean;
    preview?: string;
    onSelect: (responses: boolean) => void;
}) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-shrink-0 overflow-hidden px-5 pt-4 [scrollbar-gutter:stable] sm:px-8">
            <div className="mx-auto w-full max-w-3xl">
                <div
                    role="tablist"
                    aria-label={t('modules.calendar.form.viewTitle')}
                    className="inline-flex max-w-full flex-wrap gap-1 rounded-3xl bg-woodyBrown/5 p-1"
                >
                    {(['details', 'responses'] as const).map(tab => {
                        const responses = tab === 'responses';
                        const selected = responsesSelected === responses;
                        return (
                            <button
                                key={tab}
                                type="button"
                                role="tab"
                                id={`event-${tab}-tab`}
                                aria-controls={`event-${tab}-panel`}
                                aria-selected={selected}
                                tabIndex={selected ? 0 : -1}
                                onClick={() => onSelect(responses)}
                                onKeyDown={event => {
                                    const next =
                                        event.key === 'Home'
                                            ? false
                                            : event.key === 'End'
                                            ? true
                                            : event.key === 'ArrowLeft' ||
                                              event.key === 'ArrowRight'
                                            ? !responses
                                            : undefined;
                                    if (next === undefined) return;
                                    event.preventDefault();
                                    onSelect(next);
                                    document
                                        .getElementById(
                                            next
                                                ? 'event-responses-tab'
                                                : 'event-details-tab',
                                        )
                                        ?.focus();
                                }}
                                className={cx(
                                    'inline-flex flex-wrap items-center gap-1 rounded-full px-3 py-1.5 text-sm font-medium transition-colors',
                                    selected
                                        ? 'bg-woodyBrown text-lightPeach'
                                        : 'text-woodyBrown/70 hover:bg-lightPeachMonoChrome hover:text-woodyBrown',
                                )}
                            >
                                {t(
                                    responses
                                        ? 'modules.calendar.responseStatus.tabLabel'
                                        : 'modules.calendar.form.detailsTab',
                                )}
                                {responses && preview ? (
                                    <span>· {preview}</span>
                                ) : null}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
